import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "grid grid-cols-[minmax(110px,1fr),minmax(110px,1fr),minmax(50px,80px),minmax(110px,1fr),20px] md:grid-cols-[minmax(110px,1fr),minmax(110px,1fr),60px,minmax(100px,1fr),70px] lg:grid-cols-[minmax(160px,200px),210px,150px,150px,1fr] gap-x-2 md:gap-2 t-12r text-wrh-gray-dark cursor-pointer border-wrh-blue-background border-b-1 md:mx-6 transition-all duration-600 lg:t-14r lg:hover:bg-wrh-blue-background item-center mx-4" }
const _hoisted_2 = { class: "py-4 break-all" }
const _hoisted_3 = {
  key: 0,
  class: "py-4"
}
const _hoisted_4 = { class: "py-4 uppercase" }
const _hoisted_5 = {
  key: 1,
  class: "py-4"
}
const _hoisted_6 = {
  key: 2,
  class: "py-4"
}
const _hoisted_7 = {
  key: 3,
  class: "py-4"
}
const _hoisted_8 = { class: "hidden justify-between md:justify-start items-center text-wrh-blue-light md:flex -mx-4 px-4 py-2 md:mx-0 md:p-0" }
const _hoisted_9 = {
  key: 0,
  class: "block t-12m md:hidden"
}
const _hoisted_10 = {
  title: "Download File",
  class: "md:mr-3 ml-auto md:ml-0"
}
const _hoisted_11 = {
  key: 1,
  title: "View File",
  class: "hidden md:block"
}
const _hoisted_12 = { class: "px-1 py-1" }

import {
  ref, toRefs, onMounted, watch,
} from 'vue';
import {
  Menu, MenuItems, MenuItem, MenuButton,
} from '@headlessui/vue';
import { format } from 'date-fns';
import Download from '@/components/icons/DownloadIcon.vue';
import ShowPassword from '@/components/icons/ShowPasswordIcon.vue';
import MoreAction from '@/components/icons/MoreActionIcon.vue';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  props: {
    document: { type: null, required: true }
  },
  emits: ['download', 'view'],
  setup(__props: any, { emit }) {

const props = __props as {
  document: any,
}


const { document } = toRefs(props);

const viewPoint = ref(false);

const checkFileType = () => {
  if (document.value.fileExtension === 'pdf') {
    viewPoint.value = true;
  }
};

onMounted(() => {
  checkFileType();
});

const fileName = ref('');

const downloadFile = () => {
  if (!store.getters.isLoginAsAdmin) {
    emit('download');
  }
};

const viewFile = () => {
  emit('view');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(document).title), 1),
    (_unref(document).uploadedAt)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(format)(new Date(_unref(document).uploadedAt), 'MM/dd/yyyy')), 1))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(document).fileExtension), 1),
    (_unref(document).documentType == 'communities')
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Your Community"))
      : _createCommentVNode("", true),
    (_unref(document).documentType == 'divisions')
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Company"))
      : _createCommentVNode("", true),
    (_unref(document).documentType == 'homes')
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Specific to your Home"))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      (viewPoint.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Open Document"))
        : _createCommentVNode("", true),
      _createElementVNode("i", _hoisted_10, [
        _createVNode(Download, { onClick: downloadFile })
      ]),
      (viewPoint.value)
        ? (_openBlock(), _createElementBlock("i", _hoisted_11, [
            _createVNode(ShowPassword, { onClick: viewFile })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Menu), {
      as: "div",
      class: "relative self-center md:hidden"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_unref(MenuButton), { class: "w-full focus-visible:outline-none focus:outline-none" }, {
            default: _withCtx(() => [
              _createVNode(MoreAction, { class: "w-4 h-4" })
            ]),
            _: 1
          })
        ]),
        _createVNode(_Transition, {
          "enter-active-class": "transition duration-100 ease-out",
          "enter-from-class": "transform scale-95 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100",
          "leave-active-class": "transition duration-75 ease-in",
          "leave-from-class": "transform scale-100 opacity-100",
          "leave-to-class": "transform scale-95 opacity-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(MenuItems), { class: "absolute right-0 w-38 z-10 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg focus:outline-none" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  (viewPoint.value)
                    ? (_openBlock(), _createBlock(_unref(MenuItem), { key: 0 }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: "text-wrh-gray-medium group flex rounded-md items-center w-full p-3 text-sm",
                            onClick: viewFile
                          }, "View Document ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(MenuItem), null, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "text-wrh-gray-medium group flex rounded-md items-center w-full p-3 text-sm",
                        onClick: downloadFile
                      }, "Download ")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})